import React from "react";
import { ListItemImage } from "../styles/styles";
import { ArrowCounterClockWise } from "../Atoms/Icons/ArrowCounterClockWise";
import { useTranslation } from "@coworker/locales";
import {
  NewOrExistingFile,
  useNewOrExistingFileUrls,
} from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

interface MediaImageItemProps {
  image: NewOrExistingFile;
  index: number;
  onUpdate: (image: NewOrExistingFile) => void;
}

export const MediaImageItem = ({
  image,
  index,
  onUpdate,
}: MediaImageItemProps) => {
  const { t } = useTranslation();

  const handleRotateImage = async (
    image: NewOrExistingFile,
    index: number
  ): Promise<void> => {
    image.rotation = image.rotation ? (image.rotation + 90) % 360 : 90;
    const carouselImage = document.getElementById(`${image.type}-${index}`);
    if (carouselImage) {
      carouselImage.style.transform = "rotate(" + image.rotation + "deg)";
    }

    onUpdate(image);
  };

  const src = useNewOrExistingFileUrls([image])[0]!;

  return (
    <div style={{ position: "relative" }} key={`${image.type}-${index}`}>
      <React.Fragment>
        <ListItemImage
          id={`${image.type}-${index}`}
          key={`${image.type}-${index}`}
          src={src}
          $rotation={image.rotation || 0}
        />
        <div
          onClick={() => {
            void handleRotateImage(image, index);
          }}
        >
          <ArrowCounterClockWise />
        </div>
      </React.Fragment>
    </div>
  );
};
